import { DateRange } from "react-day-picker";

import { DatePickerWithRange } from "@/components/DatePickerWithRange";

interface DateValueInputProps {
  date: DateRange | undefined;
  onChange: (nextDate: DateRange | undefined) => void;
  onApply: () => void;
  canApply: boolean;
  singleDateSelection?: boolean;
}

const DateValueInput = ({
  date,
  onChange,
  onApply,
  canApply,
  singleDateSelection = false,
}: DateValueInputProps) => (
  <div className="px-2 py-1">
    <DatePickerWithRange
      date={date}
      setDate={onChange}
      datetime
      includeSeconds
      hidePresets
      removable={false}
      singleDateSelection={singleDateSelection}
      showApplyButton
      applyDisabled={!canApply}
      onApply={onApply}
      className="w-full [&_button#date]:h-8 [&_button#date]:w-[300px] [&_button#date]:min-w-0 [&_button#date]:max-w-[300px] [&_button#date]:truncate [&_button#date]:bg-white [&_button#date]:py-1"
    />
  </div>
);

export default DateValueInput;
